import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister all existing service workers and start fresh
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // First, unregister all old service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then(() => {
          console.log('Unregistered old service worker');
        });
      });
    });

    // Clear all caches
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
          console.log('Deleted cache:', name);
        });
      });
    }

    // Don't register a new service worker - let React handle everything
    console.log('Service worker disabled - using fresh content only');
  });
}
